<template>
    <div
        :class="[
            'bubble-headline',
            {
                'force-left-alignment': forceTextAlignLeftOnMobile,
            },
        ]"
    >
        <div v-if="showBubble" class="bubble filled">{{ bubbleContent }}</div>
        <component
            :is="headlineTag"
        >{{ processedHeadlineContent }}</component>
    </div>
</template>

<script>
import { safeGetJson } from "../utils/safeStorage";
import { getTokenValue, resolveTextTokens } from "../utils/textTokens";

export default {
    name: "BubbleHeadline",
    props: {
        showBubble: {
            type: Boolean,
            default: true,
        },
        bubbleContent: {
            type: String,
            default: "",
        },
        headlineTag: {
            type: String,
            default: "h3",
            validator: function (value) {
                return ["h1", "h2", "h3", "h4", "h5"].includes(value);
            },
        },
        headlineContent: {
            type: String,
            default: "",
        },
        forceTextAlignLeftOnMobile: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        processedHeadlineContent() {
            return resolveTextTokens(this.headlineContent, ({ storageKey, pathParts }) => {
                const storedObject = safeGetJson(storageKey, null);
                return getTokenValue(storedObject, pathParts);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;
.bubble-headline {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 16px;
    width: 100%;

    @media (max-width: $breakpoint-mobile) {
        justify-content: center;
        text-align: center;
    }

    &.force-left-alignment {
        @media (max-width: $breakpoint-mobile) {
            justify-content: flex-start;
            text-align: left;
        }
    }

    > * {
        margin: 0;
    }

    .bubble {
        @media (max-width: $breakpoint-mobile) {
            display: none !important;
        }
    }
}
</style>
